export default {
    GET_USERS: "access/v1/getusers/",
    GET_USERS_TRAVEL: "access/v1/fetchusers/",
    GET_USER_PENDING_ITEM: "access/v1/pendingitems/",
    GET_USER_HISTORY_ITEM: "access/v1/itemhistory/",
    GET_USER_ADHOC_ITEM: "access/v1/adhocitems/",
    GET_PRODUCT_NAMES: "entity/v1/org-products/",
    DISCOVER_PRODUCTS: "entity/v1/discover-products/",
    CONTAINER_TYPES: "entity/v1/container-types/",
    DEFAULT_APPROVERS: "access/v1/const-approver-mapping/",

    SETTLEMENT_TABLE_FIELD_API: "settlement/v2/gettableandfields/",
    SETTLEMENT_FILTER: "settlement/v2/filters/",
    SETTLEMENT_MUTLI_OPTION: "settlement/v2/multiselect_options/",
    SETTLEMENT_CONDITION: "settlement/v2/conditions/",
    SETTLEMENT_NEW_METHOD: "settlement/v2/methods/",
    SETTLEMENT_EXCEL: "settlement/v2/export_config/",
    SETTLEMENT_ALL_NEW_API: "settlement/v2/settlement/",
    SETTLEMENT_FILTER_EXTRAFIELD: "settlement/v2/get_extra_field/",
    SETTLEMENT_NEW_DOWNLOAD: "settlement/v2/export/",
    SETTLEMENT_CONTAINER: "settlement/v2/container_settlement/",
    USER_SETTLEMENT: "settlement/v2/user_settlement/",
    SETTLE_NOW: "settlement/v2/settle_now/",
    SETTLED_DATE: "settlement/v2/last_txn/",

    GET_SETTLEMENT_DATA: "transaction/v1/settle/",
    SETTLEMENT_METHOD: "transaction/v1/settlementmethod/",
    SETTLEMENT_FINAL_EMP: "transaction/v1/makesettlement/",
    GET_SETTLEMENT_RULES: "transaction/v1/settlementcondition/",
    GET_PAYMENTHISTORY_DATA: "billpayment/v1/gettransactionstatus/",
    VIEW_BILL_DATA: "billpayment/v1/getbill/",
    REGISTER_COMPLAINT: "billpayment/v1/registercomplaint/",
    CONV_RATE_EXPENSE: "transaction/v1/currency-conversion-rate/",

    GET_ALL_PENDING_ITEMS: "access/v1/unsubmitteditems/",
    GET_ORG_SETTLEMENT: "transaction/v1/orgexpensesummary/",
    GET_ORG_INVOICES: "invoiceengine/expense/invoice/",
    GET_INVOICE_LINK: "invoiceengine/expense/invoiceaction/",
    /* Roletype related */

    ADD_ROLETYPE: "access/v1/addroletype/",
    EDIT_ROLETYPE: "access/v1/editroletype/",
    GET_ROLETYPES: "access/v1/getroletypes/",
    DELETE_ROLETYPES: "access/v1/deleteroletype/",
    DEACTIVATE_ROLETYPES: "access/v1/deactivateroletype/",
    RESEND_EMP_INVITE: "access/v2/reinvite/",
    GET_ALL_ROLE_EMPLOYEE: "access/v2/getorgroles/",
    EDIT_ROLE_AND_APPROVERS: "access/v2/rolesandsuperiors/",
    EDIT_APPROVERS_OF_SUPER_USERS: "access/v2/editsuperuser/",
    ASSIGN_APPROVERS: "access/v3/addsupervisor/",
    DEASSIGN_APPROVERS: "access/v3/removesupervisor/",
    ASSIGN_ROLE: "access/v3/addrole/",
    DEASSIGN_ROLE: "access/v3/removerole/",
    CHANGE_EMAIL_ID_USER: "access/v2/edituser/",
    OTP_FOR_MOBILE_CHANGE: "access/v1/generateotp/",
    TYPE_OF_UPDATE: "newbulkengine/v1/get-mapper-fields/",
    DOWNLOAD_BULK_USER: "newbulkengine/v1/download/",
    CHANGE_MOBILE_NUMBER: "access/v3/editmobilenumber/",
    VERIFY_MOBILE_OTP: "access/v2/verifyotp/",

    GET_ALL_DELEGATIONS: "access/v2/delegate/",
    DELETE_DELEGATION: "access/v1/delegate/",
    ADD_DELEGATION: "access/v1/delegate/",
    SWITCH_TO_DELEGATION: "access/v1/siwtchtodelegated/",
    EXIT_DELEGATION_SWITCH: "access/v1/exitfromdelegated/",
    GET_DELEGATION_ROLE_TYPES: "access/v2/delegateroletypes/",

    CREATE_GROUP: "access/v2/register/",
    EDIT_GROUP: "access/v1/editgroup/",
    GET_GROUPS: "access/v1/getgroups/",

    MANAGE_USER_ASSIGN: "access/v1/manageusersassignment/",
    GET_PAYMENT_GROUP: "access/v1/getpaymentgroups/",
    EMP_EXTRAFIELD: "access/v1/empextrafield/",

    GET_ALL_POLICIES: "policy/v1/get-all-policies/",
    GET_POLICIES: "policy/v1/policy/",
    ADD_CRITERIA: "policy/v1/classificationunit/",
    ADD_ATTRIBUTE: "policy/v1/attribute/",
    ADD_POLICY: "policy/v1/policy/",
    GET_PERIODS: "policy/v1/periodicity/",
    GET_BUDGETPOLICYDETAILS: "policy/v1/attributebudget/",
    POLICY_VALIDATION: "policy/v1/policyvalidation/",

    EMP_INVITE: "access/v2/empinvite/",
    PENDING_EMP_INVITE: "access/v1/invitepending/",
    DELETE_EMP_INVITE: "access/v1/deleteempinvite/",

    PRELOGIN_FETCH: "access/v1/fetchauthmode/",
    LOGIN: "access/v1/login/",
    PRELOGIN_SEND_OTP: "access/v1/sendotp/",
    PRELOGIN_VERIFY_OTP: "access/v1/verifyotp/",
    PRELOGIN_VERIFY_EMAIL: "access/v1/sendemailverificationlink/",
    PRELOGIN_CREATE_SUPER_USER: "access/v2/register/",
    PRELOGIN_CREATE_USER: "access/v2/register/",
    COUNTRYCODE_TYPEAHEAD: "access/v1/countrycode/",
    VERIFY_EMAIL_ID: "access/v1/verifyemail/",

    WORKFLOWDATA_ALL: "workflow/v1/workflows/",
    CLONE_WORKFLOW: "workflow/v1/workflow-clone/",
    WORKFLOW_MOVE_OUT: "workflow/v1/statemoveout/",
    ALLWORKFLOWSTATEDATA_FETCH: "workflow/v1/states/",
    GETCONTAINER_FETCH: "workflow/v1/containers/",
    GETATTRIBUTE_FETCH: "workflow/v1/container-attributes/",
    GETROLES_FETCH: "access/v1/getroletypes/",
    GETLOGICALUNITS_ALL: "workflow/v1/logical-units/",
    GETSTATECONDITIONS_ALL: "workflow/v1/state-conditions/",
    GETSTATESETTIGNS_ALL: "workflow/v1/state-settings/",
    NOTIFICATION_ATTRIBUTES: "workflow/v1/notification-attributes/",
    REMNOTIFICATION_ALL: "workflow/v1/reminder-notifications/",
    STATENOTIFICATION_ALL: "workflow/v1/state-notifications/",
    EXPNOTIFICATION_ALL: "workflow/v1/expiry-notifications/",
    GETCONTAINERTYPE_FETCH: "workflow/v1/workflow-type-status/",
    GETGROUPS_FETCH: "access/v1/getgroups/",
    GETTEMPLATE_FETCH: "notification/v1/getorgnotlist/",
    GETSTATUS_FETCH: "custom-status/v1/status/",
    GETSIGLESTATUS_FETCH: "custom-status/v1/status-details/",
    GETSTATUSTYPE_FETCH: "custom-status/v1/container-status/",
    GETCONTAINER_HISTORY: "history/v1/containerhistory/",
    WORKFLOW_FORCE_EXIT: "workflow/v1/force-exit/",
    DISPLAY_BILL_USER: "gallery/v3/displaybilluser/",
    DOWNLOADPOLICY_EXCEL: "policy/v1/policy-export-excel/",
    EXPORT_WORKFLOW: "workflow/v1/work_flow_export_mail/",
    ORG_ACTIVE_WORKFLOW: "workflow/v1/org-active-workflows/",
    WF_STATE_LIST: "workflow/v1/wf-states-list/",
    WF_LOGICAL_UNITS: "workflow/v1/wf-configured-lus/",
    BULK_STATE_CONDITION: "workflow/v1/bulk-state-conditions/",

    GET_ETL_CONFIGURATIONS: "etl/v1/getconfigurations/",
    DELETE_ETL_CONFIG: "etl/v1/deleteconfiguration/",
    DOWNLOAD_ETL: "etl/v1/download/",
    DOWNLOAD_WORKFLOW_COMMENT: "search/v1/get-export/",
    POLICY_EXCEPTION_REPORT_TRF: "policy/v1/trfpolicyexceptionreport/",
    POLICY_EXCEPTION_REPORT: "policy/v1/policyexceptionreport/",
    CONTENT_TYPES: "etl/v1/getcontenttypes/",
    GET_ETL_FIELDS: "etl/v1/getfields/",
    SAVE_ETL_CONFIG: "etl/v1/saveconfiguration/",
    EDIT_ETL_CONFIG: "etl/v1/editconfiguration/",
    GET_CONTROLLED_USER: "access/v2/controlledusers/",
    GET_COMBINED_CONTROLLED_USER: "access/v2/controlleduserscombined/",
    DOWNLOAD_ETL_REPORT: "etl/v1/sendtestmail/",
    DOWNLOAD_REPORT: "report/v1/report-pdf/",
    DOWNLOAD_EXPENSE: "transaction/v1/expensexport/",
    DOWNLOAD_EXPORT_EXCEL: "report/v1/report-expenses-download/",
    DOWNLOAD_TRF: "trf/v1/trfpdf/",
    EXCHANGE_PARENT_TREE: "transaction/v1/transactiontree/",
    DOWNLOAD_PDF_STATE_CHECK: "pdf/v1/get-template-status/",
    DOWNLOAD_DISBURSEMENT_SURRENDER_PDF: "trf/v1/trip_disbursement_surrender_pdf/",
    DOWNLOAD_MR: "card/v1/mrpdf/",
    SMART_AUDIT_REPORT_EXPORT: "intelligence-system/v1/smart-audit-export/",
    AUTHENTICATE_VOICE: "authentication/v1/autheticatevoiceit/",

    GET_EXTRA_FIELD: "extrafields/v1/extrafields/",
    TRANSACTION_EXTRA_FIELD: "extrafields/v1/getfields/",
    DEL_EXTRA_FIELD: "extrafields/v1/deleteextrafields/",
    GET_NATIVE_EXTRA_FIELD: "extrafields/v1/getnativefields/",
    GET_RESOURCE_NAME: "extrafields/v1/getresourcename/",
    GET_OVERRIDE_FIELD: "extrafields/v1/overridefields/",
    GET_USER_INFO: "access/v1/getuserinfo/",
    EDIT_USER_INFO: "access/v1/edituserinfo/",
    GET_USER_ROLES_GROUPS: "access/v1/rolesandgroups/",
    GET_ORG_BALANCE: "organisation/v1/getorgbalance/",
    GET_PERMISSION: "access/v2/permissions/",
    DELETE_USER: "access/v1/userdelete/",
    USER_NOTIFICATIONS: "notification/v1/userunsubscribemail/",
    MAIL_FORWARD_ID: "happay_apps/v1/mailforward/get_app_org_id/",

    GET_SEARCH_FIELDS: "search/v1/searchfields/",
    GET_SEARCH_RECORDS: "search/v1/search/",
    GET_REPORT_SEARCH: "search/v1/report_search/",
    GET_CLASSIFICATION: "policy/v1/classification/",
    ADD_PERIOD: "policy/v1/periodicity/",
    LINE_ITEM: "workflow/v1/container-attributes/",
    CONTAINERS: "workflow/v1/containers/",
    GET_PARTICULAR_STATUS_TYPE_INFO: "custom-status/v1/status/",
    GET_STATUS_TYPE: "custom-status/v1/container-status/",
    ALL_TXN_TYPE: "transaction/v1/alltransactiontype/",
    ORG_SYS_TXN: "transaction/v1/sysdefinedtxn/",
    CURRENCY_TYPE: "organisation/v1/currencylist/",
    ORG_CURRENCY: "organisation/v1/configorgcurrency/",
    ALLOWED_MONEYTYPE_CURR: "trf/v1/allowedmoneytypecurrency/",
    SAVE_TABLE_CONFIG: "search/v1/columns/",
    SAVE_TABLE_CONFIG_ORG: "search/v1/orgcolumns/",
    GET_VIRTUAL_ACCOUNT: "virtualaccount/v1/virtualaccount/",
    GET_VIRTUAL_ACCOUNT_DETAIL: "virtualaccount/v1/orgbankaccountadmin/",

    REPORT_CREATE: "report/v1/report/",
    REPORT_DETAILS: "report/v1/report-details/",
    REQ_TYPE_GRP_BY_EXP: "trf/v1/getrequesttypevalues/",
    FETCH_EXISTING_TRANSACTIONS: "report/v1/existing-transactions/",
    REPORT_SAVE: "report/v1/report-save/",
    REPORT_SAVE_WORKFLOW: "report/v1/report-save-workflow/",
    REPORT_SUBMIT: "report/v1/report-submit/",
    REPORT_USER_CONFIRM: "report/v1/confirmation/",
    REPORT_DELETE: "report/v1/report-delete/",
    GET_REPORT_AUTOMATION_META_DETAILS: "automation/v1/metadetail/?content_type=1",
    SET_REPORT_AUTOMATION: "automation/v1/report/",
    SET_REPORT_AUTOMATION_EMP: "automation/v1/emp_report/",
    GET_REPORT_AUTOMATION: "automation/v1/report/",
    GET_EMP_REPORT_AUTOMATION: "automation/v1/emp_report/",
    GET_REPORT_METACTIONS: "automation/v1/metaactions/",
    GET_REPORT_ACTIONS: "automation/v1/actions/",
    GET_ATTACH_REPORT_TRIP: "report/v1/get-all-reportable-trips",

    // DA related APIs
    DA_TO_TR_MAPPING: "daily-allowance/v1/tr-da-mapping/",
    DA_CONFIG: "daily-allowance/v1/da-config/",
    DA_TO_TRF_MAPPING: "", // pending from backend
    DA_TRAVEL_DETAILS: "daily-allowance/v1/travel-detail/",
    DA_TRAVEL_ATTACHMENT: "daily-allowance/v1/add-attachment/",
    DA_TRAVEL_HISTORY_DETAILS: "daily-allowance/v1/travel-history/",
    DA_TRIP_TIMELINE: "daily-allowance/v1/travel-daily-breakup/",
    DA_ADD_ATTACHMENTS: "daily-allowance/v1/add-attachment/",
    DA_TRAVEL_ALLOWANCE: "daily-allowance/v1/travel-allowance/",
    DA_TRANSACTION: "daily-allowance/v1/da-created-txn/",
    FETCH_DA_DETAILS: "travel_cart/v1/fetch_da_details/",
    GET_REPORT_CONFIG: "report/v1/report-config/",
    DELETE_REPORT_CONFIG: "report/v1/report-config-details/",
    EDIT_REPORT_CONFIG: "report/v1/report-config-details/",
    ADD__REPORT_CONFIG: "report/v1/report-config/",

    /* Report Template */
    GET_REPORT_TEMPLATE: "report/v1/report-template/",
    /* CARD APIs */
    GET_CARD_TYPES: "card/v1/cardtypes/",
    PLACE_CARD_ORDER: "card/v1/cardorder/",
    GET_CARD_INVENTORY: "card/v1/cardinventory/",
    GET_ASSIGNED_CARD: "card/v1/assignedcards/",
    GET_UNASSIGNED_CARD: "card/v1/unassignablecards/",

    ASSIGN_CARD: "card/v1/assigncard/",
    ASSIGN_WALLET: "wallet/v1/attachwallet/",
    CARD_LOAD_MONEY: "wallet/v1/loadwallet/",
    CARD_WITHDRAW_MONEY: "wallet/v1/withdrawwallet/",
    UPDATE_CARD_STATUS: "card/v1/changecardstatus/",
    GET_CARD_HISTORY: "card/v1/cardstatushistory/",
    GET_RECENT_HISTORY: "card/v1/recentcardhistory/",
    VIRTUAL_TRANSACTION: "card/v1/virtaultransaction/",
    ADD_DIGITAL_CARD: "card/v1/digitalcard/",
    DETACH_CARD: "card/v1/detachcard/",
    WALLET_LOAD_LIMIT_HISTORY: "wallet/v1/limitplanlog/",
    GET_WALLET_TRANSFER: "wallet/v1/getwalletnonhappay/",
    REPLACE_CARD: "card/v1/replace-cards/",

    SAVE_SEARCH_VALUES: "search/v1/searchconfiguration/",
    DELETE_TABLE_DATA: "transaction/v1/transaction/",

    GET_CUSTOM_STATUS: "custom-status/v1/status/",
    TXN_TYPE: "transaction/v1/transactiontype/",
    PARTICULAR_TXN_TYPE: "transaction/v1/transactiontype/id/",
    CURRENCY_TYPE: "organisation/v1/currencylist/",
    ADD_EXPENSE: "transaction/v1/transaction/",
    ADD_DA_BULK_EXPENSE: "daily-allowance/v1/da-bulk-txn-creation/",
    ADD_CATEGORY: "transaction/v1/category/",
    CHANGE_CATEGORY_STATUS: "transaction/v1/category/id/",
    EDIT_CATEGORY: "transaction/v1/categoryedit/",
    EDIT_CATEGORY_1: "transaction/v1/category/id/",
    GET_CATEGORY_MCC: "transaction/v1/mcc-codes/",
    CHANGE_PASSWORD: "access/v1/setpassword/",
    GET_OTP_FOR_PASS_CHANGE: "access/v1/generateotp/",
    GET_SINGLE_TRANSACTION: "transaction/v1/transaction/id/",
    Bill_Attachment: "transaction/v1/attachments/",
    SHARE_ACCEPT: "transaction/v1/actiontaken/",

    GET_TRAVEL_REQUEST: "trf/v1/gettravelrequest/",
    GET_TRAVEL_ALLOWANCE: "trf/v1/gettravelrequests/",
    GET_TRAVEL_CONFIG: "trf/v1/gettravelexpenseconfig/",
    SET_TR_EXPENSE: "trf/v1/settravelexpense/",
    DELETE_TR_EXPENSE: "trf/v1/deleteexpensetxn/",
    DELETE_TRF: "trf/v1/deletetrf/",
    GET_TRF_WF_SETTING: "trf/v1/trfworkflowsetting/",
    SET_TRF_WF_SETTING: "trf/v1/trfworkflowsetting/",
    GET_TRF_WALLET_SETTING: "trf/v1/walletactionsetting/",
    SET_TRF_WALLET_SETTING: "trf/v1/walletactionsetting/",
    UNDO_MODIFIED_TRF: "trf/v1/undomodification/",
    GET_UPDATED_PRICE: "travel/v1/updated_price/",
    PUT_PREFERENCES: "trf/v1/preference/",
    TRF_REGEX: "trf/v1/trf_field_regex/",
    TRF_VALIDATION: "trf/v1/trfformvalidations/",
    TRAVEL_PRODUCT_CONFIG: "travel_cart/v1/travel_products/",
    TRAVEL_GST_LOGICAL_UNITS: "travel-booking/v1/config_logical_unit/",
    AUTO_COM_CITY: "travel/v1/airports/",
    PRODUCT_LIST: "travel_cart/v1/org_config_prod_list/",
    TRAVEL_PRODUCT_DTL: "travel_cart/v1/org-travel-product-config/",
    LOGICAL_UNIT_SELCTION: "travel-booking/v1/logical_unit_selection/",
    TRAVEL_WF_CONFIG: "travel_cart/v1/wf_config/",
    TRAVEL_CONFIG_DATA: "travel-booking/v1/config_structure/",
    CONTAINER_ITEMS: "travel_cart/v1/travel-container-items/",
    TRAVEL_GSTIN_DETAILS: "travel-booking/v1/logical_unit_selection/",
    TRAVEL_CONTANIER_ATT: "travel_cart/v1/travel_container_attribute/",
    STATE_LIST: "organisation/v1/statelist/",
    AUTO_BOOKING_ACTION_MAP: "travel-booking/v1/backend_action_map/",
    GET_TRAVEL_CONFIG_FIELDS: "trf/v1/gettravelexpenseconfig/",
    WALLET_BALANCE_CONFIG: "travel_cart/v1/org_wallet_amount_config/",
    SET_TRAVEL_CONFIG: "trf/v1/settravelexpenseconfignew/",
    DELETE_TRAVEL_CONFIG: "trf/v1/settravelexpenseconfignew/",
    GET_CONTEXT_FIELD: "trf/v1/getcontextconfig/",
    CREATE_TRAVEL_REQUEST_FORM: "trf/v1/settrf/",
    CREATE_TRAVEL_REQUEST: "trf/v1/settravelreq/",
    FETCH_TRAVEL_REQUEST: "trf/v1/gettrf/",
    TRAVEL_STATUS_CONFIGURATION: "trf/v1/trfstatusconfig/",
    DELETE_TRAVEL_REQUEST: "trf/v1/deletetravelreq/",
    VIEW_TA_PENDING_TRF: "trf/v1/viewtapendingtrf/",
    FETCH_CA_LIST: "trf/v1/trfcitylist/",
    TRF_MONEY_CONFIG: "trf/v1/moneyconfig/",
    ADMIN_SUBMIT_TRF: "trf/v1/adminmodifytrf/",
    FLIGHT_PREFERENCES: "trf/v1/preference/",
    GET_PASSBOOK_DATA: "transaction/v1/passbook/",
    GET_PASSBOOK_PDF: "transaction/v1/passbookpdf/",
    GET_SBT_CONFIG: "travel-booking/v1/inv_config_ef/",
    TRAVELLER_CONFIG: "travel-booking/v1/traveller_config/",
    GET_PASSENGER_DETAILS: "travel-booking/v1/passenger_details/",
    GET_CORPID_LIST: "travel/v1/ve_code_map/",
    CORPID_MAPPING: "travel-booking/v1/corp_id_mapping/",
    LOGICAL_CONFIG_TRAVEL: "travel-booking/v1/get_selection_type/",
    HOME_PAGE_TEXT_CONFIG: "organisation/v1/travel_home_page_msg/",
    EXPENSE_REPORT_CONFIG: "/travel_cart/v1/expense_report_config/",
    TRAVEL_EXPENSE_CONFIG: "/organisation/v1/travel_expense_req_config/",
    TRF_DELTA: "trf/v1/trip_delta/",
    FLIGHT_STAT_CONFIG: "organisation/v1/cirium_toggle/",
    DELETE_EXPENSE_TRF: "transaction/v1/adminexpensedeletion/",
    TRAVEL_DRL_CONFIG: "travel-booking/v1/travel_ef/",

    GET_ORG_WALLET: "wallet/v1/orgwallet/",
    GET_EMP_WALLET: "wallet/v1/empwallet/", // added newly for employee wallets segregated from user info
    GET_CONFIG_WALLET: "wallet/v1/walletconfig/",
    WALLET_ACCESS: "wallet/v1/walletaccess/",
    LIMIT_PLAN: "wallet/v1/limitplan/",
    DEFAULT_WALLET: "wallet/v1/defaultwallet/",
    GET_ALL_EMP_WALLET: "wallet/v1/emplistwallet/",

    SET_WALLET_LOAD_TEMP: "wallet/v1/walletloadtemplate/",
    SET_WALLET_WITHDRAW_TEMP: "wallet/v1/walletsettlementtemplate/",
    GET_CHOICE_DATA: "wallet/v1/getchoicetypedata/",
    BALANCE_TRANSFER: "wallet/v1/balancetransfer/",

    TRANSFER_CONFIG: "wallet/v1/transferconfiguration/",
    GET_VALUES: "transaction/v1/getfieldchoice/",

    /* Workflow configuration */
    TRACK_WORKFLOW: "workflow/v1/track-workflows/",
    DO_ACTION_WORKFLOW: "workflow/v1/container-action/",
    TRACK_WORKFLOW_RESOURCE: "workflow/v1/resource-details/",
    SAVE_WORKFLOW_DRAFT: "workflow/v1/draft/",
    ACTION_ON_ADHOC: "workflow/v1/requestadhoc/", // workflow/v1/requestadhoc/ad_id request with different methods
    INMAIL_ACTION: "workflow/v1/in-mail-action/",

    GETCURRENCY: "transaction/v1/conversion/",
    ORG_LOAD_MONEY: "organisation/v1/moneyrequest/",
    CONTAINERATTIBUTE: "workflow/v1/containerattribute/",
    CHANGE_CATEGORY: "transaction/v1/transaction/id/",
    ORG_PROFILE_DETAIL: "organisation/v1/basicinfo/",

    LDAP_CONFIGURATION: "access/v1/authentication-providers/",
    MONEY_REQUEST: "card/v1/moneyreq/",

    CONTROLLED_USER_INFO: "access/v2/controlleduserinfo/",
    MIGRATE_FINANCIAL_ORG_USERS: "organisation/v1/migrate_financial_org_users/",

    RUNNING_CONTAINERS_CONTYPE: "extrafields/v1/getcontypeoptions/",
    CONFIG_AUTO_CREATE_ITEMS: "entity/v1/fetch-config/",

    CONTROLLED_USER_WALLETS: "access/v1/controlleduserwallets/",
    UPDATE_WALLET_STATUS: "wallet/v1/changewalletstatus/",
    WORKFLOW_STATE_POS: "workflow/v1/setcoordinate/",
    WORKFLOW_STATE_NOTIFY: "workflow/v1/statenotifications/",
    ACTIVATE_REMINDER_NOTI: "workflow/v1/activatestateconf/",
    WORKFLOW_LOGICAL_UNIT_BULK: "workflow/v1/workflow_logical_unit_bulk/",
    /* KYC related */

    UPLOAD_KYC: "access/v1/uploadkyc/",
    UPLOAD_USER_KYC: "access/v1/kycadmin/",
    MIN_KYC: "access/v1/min_kyc/",
    USER_ADDRESS: "access/v2/useraddress/",
    VIDEO_KYC: "access/v1/video-kyc/",
    KYC_DOC_TYPE: "access/v1/kyc-doc-type/",
    /* Uploading user logo */
    UPLOAD_USER_LOGO: "access/v1/upload-user-profile-pic/",

    /* Uploading organization logo */
    UPLOAD_ORG_LOGO: "organisation/v1/uploadlogo/",

    /* City and Country related */
    HAPPAY_COUNTRY_TYPEAHEAD: "organisation/v1/happaycountrytypeahead/",
    COUNTRY_TYPEAHEAD: "organisation/v1/countrytypeahead/",
    ORG_COUNTRY: "organisation/v1/orgcountry/",
    ORG_COUNTRY_GRP: "organisation/v1/countrygroup/",
    CITY_BY_COUNTRY: "organisation/v1/orgcitybycountry/",
    HAPPAY_CITY_TYPEAHEAD: "organisation/v1/happaycitytypeahead/",
    CITY_TYPEAHEAD: "organisation/v1/citytypeahead/",
    ORG_CITY: "organisation/v1/orgcity/",
    ORG_CITY_GRP: "organisation/v1/citygroup/",
    GET_ATTRIBUTES: "policy/v1/attribute/",
    ADD_QUESTION: "policy/v1/questions/",
    ADD_QUESTIONEXPRESSION: "policy/v1/questionsexpression/",
    ORG_CITY_NEW: "organisation/v2/orgcity/",

    /* -----BULK ENGINE UPLOADS------*/
    GET_FILTER: "bulk/v1/getfilters/",
    DOWNLOAD_SAMPLE: "bulk/v1/sampledownload/",
    CONTENT_DOWNLOAD: "bulk/v1/contentdownload/",
    UPLOAD_XL: "bulk/v1/exceluploader/",
    GET_BULK_STATUS: "bulk/v1/loaderhistory/",
    /* -----BULK ENGINE URLs ENDS HERE------*/

    /* -----BULK APPROVAL URLs ------*/
    GET_BULKACTION_DATA: "workflow/v1/bulkaction/",
    /* -----BULK APPROVAL URLs ENDS HERE------*/

    GET_EXTRA_FIELD_TYPES: "extrafields/v1/getchoices/",
    GET_CARD_HOTLIST: "card/v1/hostlistcard/",

    /* --------------- RECHARGE API'S-------------------*/
    GET_MOBILE_OPERATOR_CIRCLE: "utility-payment/v1/get-mobile-operator-and-circle/",
    GET_MOBILE_PLANS: "utility-payment/v1/get-utility-payment-plans/",
    RECHARGE_PAYMENT: "utility-payment/v1/make-utility-payment/",
    GET_RECHARGE_HISTORY: "utility-payment/v1/get-utility-payment-transactions/",
    GET_OPERATOR_MIN_AMOUNT: "utility-payment/v1/get-minimum-operator-amounts/",
    GET_RECENT_RECHARGE: "utility-payment/v1/get-employee-frequent-payment-amounts/",
    /* --------------- RECHARGE API'S END HERE-------------------*/

    EXPENSE_ATTACHMENT_DELETE: "transaction/v1/deleteattachments/",

    /* ---------------------- ANALYTICS ------------------------------*/
    GET_GRAPHS: "analytics/v1/chartanalytics/",
    // GET_GRAPH_DATA: "analytics/v1/graph/",
    // GET_GRAPH_CONFIG: "analytics/v1/graphconfig/",
    // GET_GRAPH_CONTENT_TYPE: "analytics/v1/getcontenttypes/",
    // GET_EXTRA_FIELD_ANAlYTICS: "analytics/v1/extrafieldinfo/",
    // GET_EXTRA_FIELD_DETAILS_ANAlYTICS: "analytics/v1/extrafielddetail/",
    // GET_WALLET_TYPES: "/wallet/v1/getwallettypes/",
    /* ---------------------- ANALYTICS ------------------------------*/

    /* --------------ACCOUNTING API's-------------------------------*/
    GET_EMPLOYEE_MAPPING: "extrafields/v1/employeemap/",
    GET_CATEGORY_MAPPING: "extrafields/v1/categorymap/",
    // ACCOUNTING_REPORT_FIELDS : 'accounting/v1/report-fields/',
    ACCOUNTING_CONSTANT_FIELDS: "accounting/v1/constant-report-fields/",
    // GET_SAVED_REPORT_NAME: 'accounting/v1/reportconfigurations/',
    GENERATE_REPORT: "accounting/v1/generate-report/",
    TALLY_COST_CENTER_CATEGORY: "extrafields/v1/createcostcentres/",
    // REPORT_CONFIGURATIONS_NAME: 'accounting/v1/report-configurations/',
    FILE_FORMAT_LIST: "accounting/v1/file-formats/",
    INDEX_APPROACH_LIST: "accounting/v1/index-approaches/",
    GENERATION_PROCESS_LIST: "accounting/v1/report-configuration-dropdowns/",
    REPORT_CONFIGURATION: "accounting/v1/report-configurations/",
    HEADER_FIELDS_DROPDOWN_LIST: "accounting/v1/header-field-dropdowns/",
    ENTRY_GROUP_DROPDOWNS: "accounting/v1/entry-group-dropdowns/",
    FILTER_CLAUSE_DROPDOWNS: "accounting/v1/filter-dropdowns/",
    GROUP_BY_DROPDOWNS: "accounting/v1/group-by-dropdowns/",
    PIVOT_TABLE_DROPDOWNS: "accounting/v1/pivot-table-dropdowns/",
    CONSTANT_REPORT_FIELDS_DROPDOWNS: "accounting/v1/constant-report-fields-dropdowns/",
    SFTP_AUTHTYPE: "accounting/v1/authentication-dropdown/",
    LOCK_REPORT_CONFIGURATION: "accounting/v1/report-lock/",
    BULK_CATEGORY_MAP: "extrafields/v1/bulk_category_map/",
    ENTRY_FIELD_METADATA: "accounting/v1/entryfield-metadetails/",
    /* --------------ACCOUNTING API's ends here-----------------------*/

    /* ---------LOAD ACCOUNT URLS STARTS HERE-----------*/
    LOAD_ACCOUNT: "wallet/v1/banktransfer/",
    GET_EXCEPTION: "policy/v1/policyexceptionreport/",
    GET_IFSC: "payment/v1/ifsccode/",
    GET_OTP: "access/v1/generateotp/",
    RECURRING_TRANSFER: "wallet/v1/banktransferconfiguration/",
    SET_EF_PRV: "extrafields/v1/setextrafields/",
    BANK_TRANSFER_BREAKUP: "organisation/v1/fee-charge/break-up/",
    /* ---------Category COnfiguration URLS go here----------*/

    GET_CATEGORYCONFIGURATION: "transaction/v1/type-wallet-category/",
    GET_CATEGORY_CHOICE: "transaction/v1/categorychoice/",
    WORKFLOW_COMMENTS: "workflow/v1/comment/",
    WORKFLOW_COMMENTS_POST: "workflow/v1/comment-v2/",

    /*currency range urls */
    SETCURRENCYRANGE: "transaction/v1/currency-conversion/",
    CURRENCYRANGEHISTORY: "transaction/v1/currency-conversion/",
    WORKFLOW_RECALL: "workflow/v1/recall/",
    WORKFLOW_UNVERIFY: "workflow/v1/unverify/",
    SSO_CHECK: "access/v2/sso/",
    SSO_CONFIGURATION: "access/v2/ssoconfig/",
    SSO_PROVIDER: "access/v2/sso_providers/",

    /* -------------------TRIGGER HISTORY-----------*/
    VIEW_TRIGGERS: "signals/viewtriggers/",
    RESEND_TRIGGERS: "signals/resenddata/",
    REQUEST_LOGS: "organisation/v1/getRequestLogs/",
    EXPORT_REQUESTLOGS: "organisation/v1/export-excel-auth-logs/",

    USER_STATUS_TOGGLE: "access/v1/deactivation/",
    INTEGRATION_APPS: "organisation/v1/getIntegrationApplications/",
    BATCH_LINE_ITEM: "organisation/v1/get-batchlineitems-request-logs/",
    CREATE_INTEGRATION_APP: "organisation/v1/createIntegrationApplication/",
    ADD_IP_ADDRESS: "organisation/v1/whitelistIpAddress/",
    REMOVE_IP_ADDRESS: "organisation/v1/whitelistIpAddress/",
    BATCH_REQUEST_ID: "organisation/v1/get-batch-request-logs/",
    CREATE_BATCH_REQUEST_ID: "organisation/v1/get-batchlineitems-request-logs/",
    ORG_TOKEN_EXTENSIOS: "organisation/v1/token-extension/",

    /* -------------------BULK RE-TRIGGER HISTORY-----------*/
    RESEND_NEW_TRIGGERS: "signals/trigger_retry_new/",
    GET_BULK_TRIGGERS: "signals/trigger_retry_new/",

    /*PASSBOOK DOWNLOAD */
    GET_ALL_PASSBOOK_DATA: "transaction/v1/passbook/export-as-excel/",

    /* SETTLEMENT DOWNLOAD */
    SETTLEMENT_DOWNLOAD: "transaction/v1/settle/",
    CURRENCY_WISE_SETTLE: "transaction/v2/settle/",

    /* Set Balance Limit */
    GET_BALANCE_LIMIT: "signals/balalert/",
    UPDATE_BALANCE_LIMIT: "signals/balalert_update/",
    SET_BALANCE_LIMIT: "signals/balalert/",
    DEFAULT_TXN_TYPE: "transaction/v1/transactiontype/id/",

    /* Utility payments */
    BILLER_CATEGORY: "billpayment/v1/getbillercat/",
    BILLER_STATES: "billpayment/v1/getstates/",
    BILLER_NAME: "billpayment/v1/getallbillers/",
    BILLER_CITY: "billpayment/v1/getcities/",

    /* complain Api */
    GET_COMPLAIN: "billpayment/v1/registercomplaint/",
    GET_ALL_COMPLAINLIST: "billpayment/v1/getcomp/",
    GET_ALL_PARAMETERS: "billpayment/v1/getbillerparams/",
    FETCH_BILL_DATA: "billpayment/v1/fetchbill/",
    CCF_CALCULATION: "billpayment/v1/getccf/",
    PAY_BILL: "billpayment/v1/paybill/",

    SEARCHABLE_EF: "search/v1/content_type_relations/",
    RE_QUERY: "payment/v1/requery/",
    FETCH_MR_CONFIG: "card/v1/money-request-config/",
    FETCH_SAVE_MR_CONFIG: "card/v1/money-request-config/",
    SEARCHABLE_EF_CONTENT_RELATION: "search/v1/content_relations/",

    /* Get Orphan employees or Unassigned users */
    GET_ORPHAN_EMP: "access/v2/get_orphan_users/",

    /*Delegation Settings */
    GET_USER_PROFILES: "access/v2/delegateroletypes/",
    ADD_DELEGATION_CONTROL: "access/v1/add-delegation-control/",

    /* Travel Bookings*/
    CITY_AIRPORTS: "travel/v1/airports/",
    FETCH_AIRLINES: "travel/v1/airlines_data/",
    FLIGHT_SEARCH: "travel/v1/flights/",
    FLIGHT_BOOK: "travel-booking/v1/book/",
    CREATE_ITINERARY: "travel-booking/v1/itinerary/",
    PRICE_CHECK: "travel-booking/v1/pricecheck/",
    ALL_BOOKINGS: "travel-booking/v1/bookings/",
    MINI_RULE: "travel-booking/v1/minirule/",
    SHARE_DETAIL: "travel/v1/flight-share/",
    CANCEL_FLIGHT: "travel-booking/v1/cancelbooking/",
    RECENT_SEARCHES: "travel/v1/recent-searches/",

    /* travel request type */
    TRAVEL_REQUEST_TYPE: "trf/v1/requesttypeconfig/",

    GET_TRAVEL_REQUEST_TYPE_VALUES: "trf/v1/getrequesttypevalues/",

    WALLET_DEDUCT_CONFIG: "travel-booking/v1/walletdeductconfig/",
    // GET_AUTO_BOOKING_CONFIG
    GET_AUTO_BOOKING_CONFIG: "trf/v1/auto_booking_config/",

    // currency exchange related
    EXCHANGE_CURRENCY_CONSTRUCT: "transaction/v1/addreportconfigurationmap/",
    GET_EXCHANGE_CURRENCY_EXPENSE: "transaction/v1/getexchangetxns/",
    EXCHANGE_CURRENCY_EXPENSE: "transaction/v1/currencyexchangetxn/",
    GET_NON_FINANCIAL_TXN_TYPES: "transaction/v1/getnonfintransactiontype/",
    /* controlled user */
    CONTROLLED_USER: "messagecontroller/v1/getmessagesbyactor/",
    ADD_CONTROLLED_USER: "messagecontroller/v1/createcmessage/",
    EDIT_CONTROLLED_USER: "messagecontroller/v1/updatemessage/",
    COMMON_MSG_TO_ALL: "messagecontroller/v1/getcontrolmessages/",

    SMS_CONFIG_CHANGE: "organisation/v1/togglesmsread/",
    // GET_EMP_CARD: "card/v1/getusercardwallet/",
    GET_EMP_CARD: "search/v1/search/",
    DEFAULT_WALLET_FOR_CARD: "wallet/v1/carddefaultwallet/",
    CONFIF_CATEGORY: "transaction/v1/categorychoice/",

    DROPDOWN_PERIODIC_CONFIG: "accounting/v1/periodicity-configuration-dropdowns/",
    POST_PERIODIC_CONFIG: "accounting/v1/report-configurations/",
    GET_PERIODIC_CONFIG: "accounting/v1/report-configurations/",
    DELETE_PERIODIC_CONGIF: "accounting/v1/report-configurations/",
    UPDATE_PERIODIC_CONGIF: "accounting/v1/report-configurations/",

    ALL_ACCOUNTING_REPORT_DATA: "accounting/v1/export-histories/",
    ALL_ACCOUNTING_LOG_DATA: "accounting/v1/log-history/",
    MODE_CHOICES: "accounting/v1/periodicity-configuration-dropdowns/",
    EXPORT_HISTORY_DROPDOWN: "accounting/v1/export-histories-dropdowns/",
    LOGOUT_V2_URL: "access/v1/logout/",
    DELETED_USER_LIST: "access/v1/deleteduserdetails/",
    BULK_SAMPLE_DOWNLOAD: "bulk/v1/file_history/",

    USER_CONSENT_ACCEPT_URL: "access/v1/log_tnc_acceptance/",
    SETTLEMENT_EXTRAFIELD: "transaction/v1/getidentifiertransactiontype/",

    // addedit transaction from admin side api
    ADD_EDIT_TXN_ADMIN_WORKFLOW: "transaction/v1/adminedittxn/",
    ADD_EDIT_TXN_ADMIN: "transaction/v1/superadminedittxn/",
    /* netbanking */
    NET_BANKING: "netbanking/bankcodes/",
    NET_BANKING_CHARGES: "netbanking/createtxnurl/",
    NET_BANKING_STATUS: "netbanking/verifytxn/",
    NET_BANKING_STATUS_TABLE: "netbanking/txnlist/",
    DISPUTE_EXPENSE: "transaction/v1/dispute_transaction/",
    WITHDRAW_DISPUTE: "transaction/v1/dispute-withdraw/",

    PDF_CONFIG: "pdf/v1/pdfconfiguration/",
    EXPORT_USER_SETTLEMENT_DATA: "settlement/v2/settlementstatement/",
    CLONE_ROLE: "access/v2/clone_role/",
    CHANGE_ROLE_STATUS: "access/v2/deactive_role/",
    GET_INVITE_DETAILS: "access/v1/get-empinvite/",
    BOOKING_TYPE: "travel-booking/v1/allwdbookingconfig/",
    BULK_ROLES_UPDATE: "access/v2/bulk_roles/",
    BULK_APPROVERS_UPDATE: "access/v2/bulk_superiors/",
    UI_INITIATE_PROCESS: "newbulkengine/v1/initate_process/",
    UI_PROCESSOR: "newbulkengine/v1/processor/",
    GET_MAPPER_FIELDS: "newbulkengine/v1/get-mapper-fields/",
    DOWNLOAD_ERROR_LOG: "newbulkengine/v1/error-download/",

    /* --------------BULK WALLET LOAD API's Starts Here------------*/
    BULK_WALLET_LOAD_UI: "bulk/v1/bulkwalletloadui/",
    /* --------------BULK WALLET LOAD API's Ends Here------------*/

    DOWNLOAD_SAMPLE_LOG: "newbulkengine/v1/sample-download/",
    MAINTAIN_STEP_VALUE: "newbulkengine/v1/move-status/",
    INTELLIGENCE_MAP: "newbulkengine/v1/i_map/",
    WALLET_LIMIT_HISTORY: "wallet/v1/walletlimithistory/",
    UPDATE_USEREF_BULK: "extrafields/v1/bulksetextrafields/",
    ASYNC_POOL: "newbulkengine/v1/pooling/",
    GET_EMPLOYEESETTLEMENT_DATA: "settlement/v2/generate_user_settlement/",

    PAYLOAD_GENERATION: "signals/sample_payload/",
    PAYLOAD_CONTAINER: "signals/getcontainers/",
    OCR_CONFIG: "transaction/v1/auto-scan-config/",
    OCR_CONFIG_DROPDOWN_LIST: "ocr/v1/ocr-config-dropdowns/",
    OCR_DATA_CONFIG: "ocr/v1/ocr-config/",
    GET_USERS_FOR_CARD_ASSIGN: "access/v1/getmyusers/",
    GET_REGEXP: "extrafields/v1/textregex/",
    VALIDATE_REGEXP: "extrafields/v1/checkregex/",
    VALIDATE_GSTIN: "extrafields/v1/get_gstin_values/",

    // GET_AUDIT_DATA: 'audit-engine/v1/audit-data/',
    GET_AUDIT_DATA: "search/v1/search/",
    GET_AUDIT_EXTRA_INFO: "audit-engine/v1/additional-info/",
    GET_AUDIT_EXPORT: "audit-engine/v1/audit-data/",
    GET_EF_AUDIT_EXPORT: "extrafields/v1/audit_log_export/",
    GET_EXTRA_FIELD_AUDIT_DATA: "extrafields/v1/get_ef_audit_log/",
    GET_EF_AUDIT_EXTRA_INFO: "extrafields/v1/get_ef_audit_log_add_info/",
    /* GENERIC PDF CONFIGURATOR TEMPLATE */
    GET_ALL_TEMPLATE: "pdf/v1/get-all-template/",
    GET_ALL_CONTAINER: "pdf/v1/getallcontainer/",
    GET_EF_NF_FIELDS: "pdf/v1/get-native-extra-fields/",
    TEMPLATE_GET_POST: "pdf/v1/create-template/",
    GENERATE_PDF: "pdf/v1/generatepdf/",
    TEMPLATE_UPDATE: "pdf/v1/update-template/",
    CHANGE_TEMPLATE_STATUS: "pdf/v1/activate-deactivate-template/",
    VIEW_VIRTUAL_CARD: "card/v1/viewcard/",

    // INTER ORG WORKFLOW
    ORG_ACESS_LIST: "access/v2/enterprise_accounts/",
    ORG_INETERCHANGE_LOGIN: "access/v2/enterprise_login/",
    /* --------------CREATE Card Pin API's Starts Here------------*/
    INIT_CARD_PIN: "card/v1/pin/init/",
    CARD_PIN_OTP: "card/v1/pin/otp/",
    CARD_PIN_OTP_RESEND: "card/v1/pin/otp/resend/",
    CARD_PIN_SET: "card/v1/pin/set/",
    ASSIGN_VIRTUAL_CARD: "card/v1/bulk/charge-card-assign/",
    DOWNLOAD_BCC: "access/v2/orgbalancecertificate_v2/",
    /*--------------CREATE Card Pin API's Ends Here------------*/

    /* --------------Expense Draft API's Starts Here------------*/
    DRAFT_UPDATE: "drafts/v1/draft-txn-detail/",
    DRAFT_SIMILAR_TXN: "drafts/v1/draft-txn-list/",
    DRAFT_BULK_UPLOAD: "ocr/v1/make-ocr-req/",
    /* --------------Expense Draft API's Ends Here------------*/

    /* -------------------- ORGLEVEL FILTERS start--------------------*/
    ORGLEVEL_CONTAINER_NAMES: "search/v1/container-display-name/",
    GET_ORGFILTER_USER: "search/v1/container-display-name/",
    GET_USER_ORG_LIST: "access/v1/get-users-via-role/",
    ADD_ORGLEVEL_FILTER: "search/v1/orgsearchconfig/",
    GET_ORG_CONFIG_DATA: "search/v1/orgsearchconfig/",
    DELETE_AND_EDIT_ORG_FILTER: "search/v1/org-search-config/",
    /* -------------------- ORGLEVEL FILTERS End--------------------*/

    APP_LIST: "happay_apps/v1/app_list/",
    APP_STATUS_CHANGE: "happay_apps/v1/activate/",
    APP_TXN_DEFAULT_VALUE: "happay_apps/v1/org_config/get_configurations/",
    ORG_NATIVE: "happay_apps/v1/native_happay_fields/",
    APP_NATIVE: "happay_apps/v1/native_app_fields/",
    APP_EXTRAFIELD: "happay_apps/v1/extra_app_fields/",
    NATIVE_MAPPING: "happay_apps/v1/native_fieldmapping/",
    EXTRAFIELD_MAPPING: "happay_apps/v1/extra_fieldmapping/",

    /* Split Transaction under split exoense */
    SPLIT_TXN: "transaction/v1/splittransaction/",
    ADMIN_SPLIT_TXN: "transaction/v1/adminsplittxn/",
    SUPER_ADMIN_SPLIT_TXN: "transaction/v1/superadminsplittxn/",
    /* Split Transaction under split exoense */

    /* -------------- Bulk Omc Card API's --------------- */
    UPLOAD_DOC_FOR_ORDER: "card/v1/uploadrcdoc/",
    BULK_SUBMIT_CARD_ORDER: "card/v1/orderomccard/",
    GET_USER_ALL_CRITERIA: "policy/v1/bulkdrafts/",
    GET_SPECIFIC_EXISTED_CRITERIA_FOR_EDIT: "policy/v1/draftsdetails/",
    BULK_SUBMIT_VEHICLE_ORDER: "omc/v1/addvehiclesinbulk/",
    UPLOAD_DOC_FOR_VEHICLE: "omc/v1/uploadvehiclerc/",
    EDIT_VEHICLE: "omc/v1/vehicle-info/",
    ACTIVATE_CARD: "omc/v1/activatecard/",
    ATTACH_USER_TO_CARD: "omc/v1/attach-user/",
    CHANGE_USER: "omc/v1/change-user/",
    GET_USERS_VEHICLES: "omc/v1/get-users-without-vehicles/",
    GET_EDIT_LIMIT: "omc/v1/vehicle-limits/",
    SET_TOGGLE_OFF: "omc/v1/hotlist-card/",
    DETACH_USER_VEHICLE: "omc/v1/detach-user-vehicle/",
    SYNC_LIMITS: "omc/v1/vehicle-limits/",
    PENDING_TRANSACTION: "omc/v1/transaction-info/",
    DELETE_VEHICLE: "omc/v1/delete-vehicle/",
    FASTAG_MAIL: "omc/v1/admininfomail/",
    UPDATE_FX_FLAG: "omc/v1/update_splash_screen_flag/",
    FASTAG_LIMIT_VIEW: "omc/v1/fastag_limit_view/",
    FASTAG_WALLET_STATUS: "omc/v1/hdfc_tag_status/",

    /* -------------- BULK POLICY API's ---------*/
    BULK_CONTAINER: "workflow/v1/bulkcontainer/",
    GET_USER_ALL_CRITERIA: "policy/v1/bulkdrafts/",
    SAVE_CRITERIA_IN_INTERVAL: "policy/v1/bulkdrafts/",
    SUBMIT_CRITERIAS: "policy/v1/bulkcriteria/",
    GET_SPECIFIC_EXISTED_CRITERIA_FOR_EDIT: "policy/v1/draftsdetails/",
    GET_DRAFT_DRAFT_IN_SHEET: "policy/v1/getdrafts/",
    GET_CRITERIA_ATTR_LIST: "policy/v1/attr-crit/",
    SUBMIT_BULK_POLICY: "policy/v1/bulkpolicy/",
    GET_DRAFT_TO_DOWNLOAD: "policy/v1/drafts-download/",
    POLICY_BULK_CONT_DETAILS: "workflow/v1/bulkcontainer/",
    GET_ALL_PAGE: "policy/v1/bulkdrafts/", // get (getting all sheet) n post (save particular sheet)
    GET_PARTICULAR_DRAFT: "policy/v1/draftsdetails/", // get submited sheet
    ATTRIBUTE_SUBMIT: "policy/v1/bulkattribute/", // post for submit
    GET_SAVE_MODE_DRAFT: "policy/v1/getdrafts/", // get save mode data

    // ----------------bulk category urls------------------
    BULK_EXPENSE_URL_KEY: "onboarding/v1/bulkexcelupload/",
    BULK_EXPENSE_URL_KEY_DOWNLOAD_CREATE: "onboarding/v1/bulksampledownload/",
    BULK_EXPENSE_URL_KEY_DOWNLOAD_UPDATE: "onboarding/v1/bulkcontentdownload/",

    SEARCH_MCC: "card/v1/search_mcc/",
    CONTYPE_SEARCH: "entity/v1/global-search/",
    SELECTED_CONTAINER_INFO: "entity/v1/runtime-container-types/",

    // ----------------bulk status url------------------
    BULK_STATUS: "custom-status/v1/bulk_status_upload/",

    /* --------------- Mearge APIs start ------------------*/
    MEARGE_EXPENSES: "transaction/v1/merge_transaction/",
    MERGE_CONFIG: "organisation/v1/get_merge_config/",
    MERGE_CONFIG_PRIORITY: "organisation/v1/txn_type_priority/",
    ACTIVATE_MERGE_TXN: "organisation/v1/active_merge_transaction/",
    AUTO_MERGE: "organisation/v1/auto_merge_activate/",
    /* --------------- Mearge APIs End  ------------------*/

    GET_PENDING_TXNS: "transaction/v1/processtxn/",

    // ----------------- Budget API Strat ----------------//
    GET_BUDGET_CONFIGRATION: "budget/v1/getbudgetconfig/",
    CREATE_BUDGET: "budget/v1/budget/",
    BUDGET_ALLOCATION: "budget/v1/allocation/",
    GET_BUDGET_INSTANCE: "budget/v1/get_budget_instances/",
    AUDIT_TRAIL: "budget/v1/get_audit_trail/",
    BUDGET_STATISTICS: "budget/v1/get_budget_statistics/",
    CHILD_BUDGET: "budget/v1/get_child_budgets/",
    BUDGET_EXPENSES: "budget/v1/get_budget_expenses/",
    BUDGET_STATUS_CHANGE: "budget/v1/status_change/",
    BUDGET_CONSUMPTION: "budget/v1/consumption/",
    BUDGET_SEARCH: "budget/v1/search/",
    BUDGET_EXPROT: "budget/v1/budget_export/",
    ENTITY_EXPORT: "budget/v1/entity_export/",
    BUDGET_SAMPLE_DOWNLOAD: "budget/v1/sample_download/",
    BUDGET_FILE_UPLOAD: "budget/v1/bulk_update_initiate/",
    BUDGET_ADD_TRACKER: "access/v1/getallusers/",
    // ----------------- Budget API END ----------------//

    // ----------------- User logs API Start ----------------//
    GET_LOGINAUDIT_LOG: "activitylogs/v1/search/",
    GET_ADOPTIONREPORT: "activitylogs/v1/scheduler/",
    SCHEDULE_ADOPTIONREPORT: "activitylogs/v1/scheduler/",
    DEACTIVATE_ADOPTIONREPORT: "activitylogs/v1/scheduler/",
    LOGIN_AUDIT_EXPORT: "activitylogs/v1/simpleexport",
    // ----------------- User logs API End ----------------//

    TRANSACTION_MAPPING_EXTRAF: "extrafields/v1/sampledownload/",
    UPLOAD_MAPPINGFILE_EF: "extrafields/v1/updateextrafields/",
    GET_DEFAULT_TEMPLATE: "pdf/v1/get-default-template/",
    GET_LANGUAGES: "locale/v1.0/locale-code-listing/",
    UPDATE_USER_LANGUAGE: "access/v1/userlocalecode/",
    /* --------------- Remote Access APIs start ------------------*/

    REVOKE_ACCESS: "access/v1/toggleadminaccess/",

    /* --------------- Mearge APIs End  ------------------*/
    /* -------------- Pasword Policy API's ---------*/
    ORG_PASSWORD_CONFIG: "organisation/v1/org-password-config/",

    /* -------------card Setting API STAT----------*/

    MANAGE_CARD_SETTING: "card/v1/limit-block-config/",
    TRAVEL_CONFIG: "card/v1/foreign-travel-config/",

    /* -------------card Setting API END----------*/

    /* -------------dispute transtion API STAT----------*/

    DISPUTE_REASONS: "transaction/v1/dispute-reasons/",

    /*-------------dispute transtion API END----------*/

    /*-------------Landing Page API STAT----------*/

    LANDING_PAGE_IMAGE: "organisation/v1/dashboard-image/",

    /*-------------Landing Page API END----------*/

    ATTACHMENTS_S3: "transaction/v1/attachments-s3/",
    ATTACHMENT_PARSED: "ocr/v1/make-ocr-lite-req/",

    /*-------------txn-action API START----------*/

    GET_TXN_ACTION: "transaction/v2/get-txn-action/",

    /*-------------txn-action API END----------*/

    /*-------------Mobile Verification API START----------*/

    MN_VERIFICATION_OTP: "access/v1/cms-verification/generate-otp",
    MN_RESEND_OTP: "access/v1/cms-verification/resend-otp",
    MN_VERIFY_OTP: "access/v1/cms-verification/submit-otp",
    /*-------------Mobile Verification API END----------*/
    /*----------------Smart Audit Start ----------------*/

    SMART_AUDIT_DROPDOWNS: "intelligence-system/v1/smart-audit-dropdowns/",
    SMART_AUDIT_CONFIG: "intelligence-system/v1/smart-audit-config/",
    SMART_AUDIT_DUPLICATE_INVOICE: "intelligence-system/v1/smart-audit-config/duplicate_invoice",
    SMART_AUDIT_INVOICE_AMOUNT_MATCH:
        "intelligence-system/v1/smart-audit-config/invoice_amount_match",
    SMART_AUDIT_RESTRICTED_INVOIVE_ITEMS:
        "intelligence-system/v1/smart-audit-config/restricted_invoice_items",
    TRANSACTION_INFO_SMART_AUDIT: "intelligence-system/v1/smart-audit-txn-info/",

    /*----------------Smart Audit End ----------------*/

    EPIC_INVOICE_MAIL: "organisation/v1/epic-invoice-info-mail/",

    /*----------------RBL TO SBM MIGRATION Start ----------------*/
    GET_RBL_SBM_MIGRATION_OTP: "access/v1/migration/send_otp/",
    RESEND_RBL_SBM_MIGRATION_OTP: "access/v1/migration/resend_otp/",
    VERIFY_RBL_SBM_MIGRATION_OTP: "access/v1/migration/verify/",
    RBL_SBM_MIGRATE_CARD_INIT_PIN: "access/v1/migration/init_pin/",
    RBL_SBM_MIGRATE_CARD_SET_PIN: "access/v1/migration/set_pin/",
    /*----------------RBL TO SBM MIGRATION Ends ----------------*/

    /*----------------TMC EMAIL CONFIG Start ----------------*/
    TMC_PRODUCT_LIST: "/travel-booking/v1/get_org_tmc_contact_list/",
    TMC_EMAIL_CONFIG: "travel_cart/v1/tmc_email_config/",
    /*----------------TMC EMAIL CONFIG Ends ----------------*/

    /*----------------SELF EMAIL CONFIG Start ----------------*/
    SELF_PRODUCT_LIST: "/travel_cart/v1/org_wise_self_product/",
    SELF_EMAIL_CONFIG: "/travel_cart/v1/self_email_config/",
    /*----------------SELF EMAIL CONFIG Ends ----------------*/

    /*--------------- Smart Expense Start ---------------*/
    SMART_EXPENSE_DETAILS: "happay_apps/v1/app-detail/",
    SMART_EXPENSE_ADMIN_DETAILS: "happay_apps/v1/admin-app-detail/",
    GENRATE_WHATSAPP_OTP: "whatsapp/v1/generate-otp/",
    VERIFY_WHATSAPP_OTP: "whatsapp/v1/verify-otp/",
    APP_REQUESTED_DETAILS: "happay_apps/v1/org_request_app/",
    /*--------------- Smart Expense End ---------------*/

    /*----------------Custom Help Manual Start ----------------*/
    CUSTOM_HELP_MANUAL: "organisation/v1/custom_help_pdf/",
    CUSTOM_HELP_VIDEOS: "organisation/v1/org_help_center_videos/",
    CUSTOM_HELP_CONTENT_VIDEOS: "organisation/v1/org_help_center_data/",
    /*----------------Custom Help Manual Ends ----------------*/

    /*---------------- Verchaska Corp config Start ----------------*/
    VERCHASKA_CORPID_PLIST: "travel_cart/v1/product_identifier_selection/",
    OFFLINE_CORP_ID: "travel_cart/v1/offline_corp_code/",
    CORPID_MAPPING: "travel_cart/v1/ve_code_mapping/",
    /*---------------- Verchaska Corp config Ends ----------------*/

    /*---------------- Base country configurations config Start ----------------*/
    BASE_COUNTRY_LIST: "organisation/v1/countrylist/",
    BASE_COUNTRY_CONFIG: "travel_cart/v1/travel-base-country/",
    /*---------------- Base country configurations config Ends ----------------*/

    /*---------------- Travel Payment config Start ----------------*/
    TRAVEL_PAYMENT_CONFIG: "travel-booking/v1/pay_config/",
    PAY_CONFIG_TOGGLE: "travel-booking/v1/pay_config_toggle/",
    PAY_USER_LIST: "access/ v1/getusers/",
    TRAVEL_AUTO_RECHARGE: "travel-booking/v1/travel_auto_sweep/",

    /*---------------- Travel Payment config Ends ----------------*/

    /*---------------- Load Company Wallet Start ----------------*/
    EXPORT_VENDOR_DETAILS: "access/v2/verdordetailscertificate_v2/",
    EXPORT_MONEY_REQUEST: "organisation/v1/moneyrequestexport/",
    EXPORT_NETBANKING_REQUEST: "netbanking/netbankingrequestexport/",
    /*---------------- Load Company Wallet Ends ----------------*/

    /*---------------- Travel TMC Support config Start ----------------*/
    TMC_SUPPORT_P_LIST: "travel-booking/v1/get_org_tmc_contact_list/",
    TMC_SUPPORT_CONFIG: "travel-booking/v1/org_tmc_contact_det/",
    /*---------------- Travel TMC Support config Ends ----------------*/

    /*----------------  TMC User Mapping Start ----------------*/
    TMC_USER_LISTVIEW: "travel_cart/v1/user_tmc_map/",
    /*----------------  TMC User Mapping Ends ----------------*/

    BIN_TYPE: "organisation/v1/bin_type/",

    /*----------------  Trip ID Search Start ----------------*/
    TRIP_ID_SEARCH: "search/v1/triptransactionfilter/",
    TRIP_REPORT_SEARCH: "search/v1/trip-report-filter/",
    /*----------------  Trip ID Search Ends ----------------*/

    /*----------------  TMC Address Config APIS Ends ----------------*/
    TMC_ADDRESS_PLIST: "travel-booking/v1/org_wise_tmc/",
    TMC_ADDRESS_CONFIG: "travel_cart/v1/tmc_address_config/",
    /*----------------  TMC Address Config APIS Ends ----------------*/

    /*----------------  TMC ORG Config Start ----------------*/
    TMC_ORG_CONFIG: "organisation/v1/update_tmc_org/",
    TRAVEL_P_DETAILS: "travel-booking/v1/travel_partner_details/",
    /*----------------  TMC ORG Config Ends ----------------*/

    OPEN_TRAVEL_TIRPS_ALLOWED: "organisation/v1/open_travel_request/",

    GET_LIVE_EXCHANGE_CUR_RATE: "transaction/v1/get-live-currency-exchange-rate/",

    /*----------------  EF export API Start ----------------*/
    EXTRAFIELD_DTL_EXPORT: "extrafields/v1/ef_details_export/",
    EXTRAFIELD_LIST_EXPORT:"extrafields/v1/ef_list_export/",
    /*----------------  EF export API Ends ----------------*/

    /*----------------  Standardised configuration API Start ----------------*/
    ROUTE_TRACKER_TRANSACTION: "transaction/v1/route-tracker-transaction-type/",
    MILEAGE_TRANSACTION: "transaction/v1/mileage-transaction-type/",
    GST_CONFIG: "extrafields/v1/ef_gstin_config/",
    /*----------------  Standardised configuration API Start ----------------*/

    /*----------------  EF export API Ends ----------------*/

    /*----------------  Notification API Start ----------------*/
    NOTIFICATION_DETAILS: "notification/v1/add-config/",
    /*----------------  Notification API Ends ----------------*/
    
    /*----------------  TMC ORG Config Start ----------------*/
    EXTRAFIELD_BULK_UPLOAD: "extrafields/v1/bulk_ef_view/",
    /*----------------  TMC ORG Config Ends ----------------*/
    FORCE_USER_KYC: "access/v1/user-additional-details/",
    USER_ADDITIONAL_INFO: "access/v1/user-additional-details/",
    
    /*----------------  MMI Config Start ----------------*/
    MMI_ACCESS_TOKEN: "map/v1/access-token-api/",
    PLACE_AUTO_COMPLETE: "map/v1/place-auto-complete/",
    PLACE_DETAILS: "map/v1/place-details-api/",
    /*----------------  MMI Config Ends ----------------*/

    /*----------------  User update Logs Start ----------------*/
    USER_UPDATE_LOGS: "activitylogs/v1/userupdatelogs/",
    USER_UPDATE_LOGS_INFO: "activitylogs/v1/userupdateloginfo/",
    /*----------------  User update Logs End ----------------*/

    /* ----------------- Company Data Export ------------- */
    COMPANY_DATA_EXPORT: "bulk/v1/company-bulk-export/",
    /* ----------------- Company Data Export End ---------- */

    /*----------------  All Approvers Start ----------------*/
    GET_ALL_APPROVERS: "report/v1/get-all-approvers/",
    /*----------------  All Approvers End ----------------*/
    /*----------------  Bulk delete api Start ----------------*/
    BULK_DELETE: "transaction/v1/txn-bulk-delete/",
    /*----------------  Bulk delete api End ----------------*/

    /*----------------  QC Card api start ----------------*/
    CARD_VIEW_QC: "card/v1/card-view/",
    PIN_SET_QC: "card/v1/card-pin-set/",
    /*----------------  QC Card api end ----------------*/
};
